export default "__VITE_ASSET__6df32594__"